<div class="confirmation-dialog">
  <h3 class="confirmation-dialog__title">
    {{ modalData.headerTranslationKey | translate }}
  </h3>

  @if (modalData.chip || modalData.entityName) {
    <div class="confirmation-dialog__additional">
      @if (modalData.chip) {
        <div class="confirmation-dialog__additional-chip">
          {{ modalData.chip }}
        </div>
      }

      @if (modalData.entityName) {
        <div class="confirmation-dialog__additional-entity">
          {{ modalData.entityName }}
        </div>
      }
    </div>
  }

  <div class="confirmation-dialog__description">
    @if (modalData.descriptionText) {
      {{ modalData.descriptionText }}
    } @else if (modalData.descriptionTranslationKey) {
      {{
        modalData.descriptionTranslationKey
          | translate: modalData.descriptionTranslationParams ?? {}
      }}
    }
  </div>

  <div class="confirmation-dialog__buttons-container">
    @if (!modalData.hideCancellation) {
      <lib-button
        (click)="cancel()"
        buttonStyle="transparent-tertiary"
        buttonSize="large"
      >
        {{ modalData.cancellationTranslationKey | translate }}
      </lib-button>
    }

    <lib-button
      (click)="confirm()"
      buttonSize="large"
    >
      {{ modalData.approvalTranslationKey | translate }}
    </lib-button>
  </div>
</div>
